import React, { useEffect,useState } from 'react'
import { useSelector } from 'react-redux';
import TimezoneSettings from './TimezoneSettings';
import SecuritySettings from './SecuritySettings';

const SettingsRHS = ({ activeTab , updateUserData , userDataFromStore}) => {

  const [component, setComponent] = useState(<></>)
  const selectedDomain = useSelector((state) => state.domain.selectedDomain)

  useEffect(() => {
    switch (activeTab) {
      case "Version":
        setComponent(<VersionComponent />)
        break;
      case "Security settings":
        setComponent(<SecuritySettings updateUserData={updateUserData} userDataFromStore={userDataFromStore} />)
        break;
      case "Timezone settings":
        setComponent(<TimezoneSettings updateUserData={updateUserData} userDataFromStore={userDataFromStore} />)
        break;
    }
  }, [activeTab])

  const VersionComponent = () => {
    return (
      <>
        <div className={`settings-RHS-version-heading ${selectedDomain}_font`}>Build Version</div>
        <div className={`settings-RHS-version-number ${selectedDomain}_font`}>v15062024.1</div>
      </>
    )
  }

  return (
    <div className='settings-RHS-main'>
      <div className='settings-content'>

        <div className={`settings-RHS-main-heading ${selectedDomain}_bold_font`}>{activeTab}</div>

        <div>{component}</div>
      </div>
    </div>
  )
}

export default SettingsRHS